import { isChrome, isEdge, isIOS } from 'react-device-detect';

/**
 * Chromium stores native Blobs (file-backed, matters for multi-MB backups);
 * other engines store `{ bytes, type }` to sidestep WebKit Blob-in-IDB bugs.
 */
export interface PackedBytes {
  bytes: ArrayBuffer;
  type: string;
}

export type StoredBlob = Blob | PackedBytes;

// Same cohort split as legacy `serializeBlob`.
const storesNativeBlob = () => (isChrome || isEdge) && !isIOS;

export const packBlob = async (blob: Blob): Promise<StoredBlob> => {
  if (storesNativeBlob()) return blob;
  return { bytes: await blob.arrayBuffer(), type: blob.type };
};

export const unpackBlob = (stored: StoredBlob): Blob => {
  if (stored instanceof Blob) return stored;
  return new Blob([stored.bytes], { type: stored.type });
};
